import { SVGProps } from 'react'
const DataIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      stroke={props.fill || '#fff'}
      d="M17.222 4.597v-.001c-.528-1.79-2.03-3.291-3.82-3.82-1.446-.42-2.267-.328-2.781.056l6.601 3.765Zm0 0c.43 1.445.326 2.26-.067 2.763m.067-2.763-.068 2.763m0 0-.006.008m.006-.008-.006.008m0 0c-.234.313-.573.503-.975.616-.406.113-.845.138-1.235.138h-2.583c-.895 0-1.487-.252-1.864-.673-.386-.431-.624-1.126-.624-2.166V3.042c0-.83.117-1.734.753-2.21l6.528 6.536Z"
    />
    <path
      fill={props.fill || '#fff'}
      d="M15.217 10.224a1.232 1.232 0 0 0-.927-.423h-3.222A2.873 2.873 0 0 1 8.197 6.93V3.708c0-.351-.153-.693-.423-.927a1.22 1.22 0 0 0-.963-.297c-2.115.27-4.06 1.43-5.328 3.177C.205 7.416-.263 9.558.142 11.7c.585 3.096 3.06 5.571 6.165 6.156.495.1.99.144 1.485.144a7.65 7.65 0 0 0 4.545-1.485c1.746-1.269 2.907-3.213 3.177-5.328a1.21 1.21 0 0 0-.297-.963Z"
    />
  </svg>
)
export default DataIcon
